var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-alert',{staticClass:"mt-3 alert",attrs:{"show":"","variant":_vm.variant}},[_c('div',{staticClass:"title mb-2"},[_c('strong',[_vm._v(_vm._s(_vm.title))])]),_vm._v(" "),_c('div',{staticClass:"message"},[_vm._v(_vm._s(_vm.message))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e082da1e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/project/components/ProjectStatusAlertComponent.vue
// module id = /wn/
// module chunks = 0